import React from "react";

const GraphSkeleton = () => {
  return (
    <div className="w-full h-full animate-pulse">
      <div className="flex flex-col space-y-8 h-full justify-end">
        <div className="relative w-full h-80 bg-gray-100 dark:bg-gray-200 rounded-lg">
          <div className="absolute bottom-0 left-0 w-full h-full flex items-end justify-around px-4">
            <div className="w-8 h-3/5 bg-gray-200 dark:bg-gray-600 rounded"></div>
            <div className="w-8 h-2/5 bg-gray-200 dark:bg-gray-600 rounded"></div>
            <div className="w-8 h-4/6 bg-gray-200 dark:bg-gray-600 rounded"></div>
            <div className="w-8 h-5/6 bg-gray-200 dark:bg-gray-600 rounded"></div>
            <div className="w-8 h-2/4 bg-gray-200 dark:bg-gray-600 rounded"></div>
            <div className="w-8 h-3/4 bg-gray-200 dark:bg-gray-600 rounded"></div>
            <div className="w-8 h-1/3 bg-gray-200 dark:bg-gray-600 rounded"></div>
            <div className="w-8 h-4/5 bg-gray-200 dark:bg-gray-600 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GraphSkeleton;
